import React from 'react';
import { GenericListPage } from '../../components/generic';
import { useProjects, Project } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';
import { useTheme } from '../../contexts/ThemeContext';
import { cn } from '../../lib/utils';

const List: React.FC = () => {
  const { colors } = useTheme();

  return (
    <div className="flex flex-col h-full min-h-0">
      {/* GenericListPage */}
      <div className="flex-1 min-h-0 overflow-hidden">
        <GenericListPage<Project>
          useData={useProjects}
          config={{
            ...moduleConfig,
            getColumns,
            getToolbarIcon,
            getTableActions,
          }}
        />
      </div>
    </div>
  );
};

export default List;

